import { FormField } from './models/form-builder/form-field.model';
import { FormInstanceElement } from './models/form-builder/form-instance-element.model';
import { FormLayout } from './models/form-builder/form-layout.model';
import { Form } from './models/form-builder/form.model';
import { LayoutCell } from './models/form-builder/layout-cell.model';
import { LayoutRow } from './models/form-builder/layout-row.model';
import { FormInstance } from './models/site-content/form-instance.model';
import { FormInstanceLoadedConditionalLogicInstructions } from './models/site-metadata/form-instance-loaded-logic-instructions.model';

export class FormInstanceHelper {

    public static OPENED_FROM_FORMS_GRID_ID_PARAM_NAME = 'openedFromId';

    // Given an array of FormFields, creates a fully formed FormInstance to "wrap" them
    public static createDummyFormInstanceFromFields(fields: FormField[], realFormInstance: FormInstance): FormInstance {
        const formInstance = new FormInstance();
        formInstance.formInstanceElements = [];
        formInstance.canEdit = true;
        formInstance.canView = true;
        // IMPORTANT: The dummy FormInstance gets assigned the Id of an actual FormInstance. This is required if the
        // Dummy FormInstance is to be passed as input to an <app-form-renderer> and in particular for any flex fields
        // to work.
        // The initial use of this method is in the AddContactDialog which uses an <app-form-renderer> to render
        // any extra fields a Contact Grid is configured with (beyond the standard ones, like Name, Phone etc.) and it passes
        // in the Id of the FormInstance which contains the Contacts Grid
        formInstance.id = realFormInstance.id; 
        formInstance.name = 'Dummy';
        formInstance.conditionalLogicInstructions = realFormInstance.conditionalLogicInstructions;

        const form = new Form();
        form.name = 'Dummy';
        form.formFields = [];
        formInstance.form = form;

        const layout = new FormLayout();
        let position = 0;
        layout.rows = [];
        form.formLayout = layout;

        for (const f of fields) {
            form.formFields.push(f);

            const el = new FormInstanceElement();
            el.formField = f;
            el.formFieldId = f.id;
            formInstance.formInstanceElements.push(el);

            const row = new LayoutRow();
            row.position = position++;
            row.cells = [];

            const cell = new LayoutCell();
            cell.formFieldId = f.id;
            cell.formInstanceElement = el;
            cell.name = f.name;

            row.cells.push(cell);
            layout.rows.push(row);
        }
        return formInstance;
    }
}
